import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import NProgress from "nprogress";
Vue.use(VueRouter);

import Layout from "@/layout";

const routes = [
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "/",
        name: "Home",
        component: HomeView,
        meta: { title: "首页" },
      },

      {
        path: "/forums/:aliase.html",
        name: "ForumsShow",
        component: () => import("../views/pages/TopForumView.vue"),
      },
      {
        path: "/search.html",
        name: "Search",
        component: () => import("../views/pages/SearchView.vue"),
      },
      {
        path: "/join",
        name: "JoinUs",
        component: () => import("../views/pages/JoinUs.vue"),
      },
      {
        path: "/wechat/login",
        name: "WechatLogin",
        component: () => import("../views/pages/wechat/LoginView.vue"),
      },
      {
        path: "/qq",
        name: "QqLogin",
        component: () => import("../views/pages/QQ/LoginView.vue"),
      },
      {
        path: "/login",
        name: "Login",
        component: () => import("../views/pages/LoginView.vue"),
      },
      {
        path: "/topic_create",
        name: "TopicCreate",
        component: () => import("../views/pages/TopicCreate.vue"),
      },
      {
        path: "/topic_edit",
        name: "TopicEdit",
        component: () => import("../views/pages/TopicEdit.vue"),
      },
      {
        path: "/topic_update",
        name: "TopicUserEdit",
        component: () => import("../views/pages/TopicUserEdit.vue"),
      },
      {
        path: "/reply_edit",
        name: "ReplyEdit",
        component: () => import("../views/pages/ReplyEdit.vue"),
      },
      {
        path: "/u/:id",
        name: "UserShow",
        component: () => import("../views/u/UserIndex.vue"),
      },
      // 重定向规则：将 /user/:id 重定向到 /u/:id  兼容之前的
      {
        path: '/user/:id',
        redirect: to => {
          return { path: `/u/${to.params.id}` };
        }
      },
      {
        path: "/reply_show",
        name: "ReplyShow2",
        component: () => import("../views/pages/ReplyShow.vue"),
      },
      {
        path: "/reply/:id",
        redirect: to => {
          return {
            path: '/reply_show',
            query: { id: to.params.id }
          }
        }
      },
      {
        path: "/user/edit/:id",
        name: "UserEdit",
        component: () => import("../views/pages/UserEdit.vue"),
      },
      {
        path: "/my",
        name: "MyShow",
        component: () => import("../views/my/IndexView.vue"),
      },
      {
        path: "terms.html",
        name: "Terms",
        component: () => import("../views/pages/TermsView.vue"),
        meta: { title: "用户须知" },
      },
      {
        path: "/link",
        name: "Link",
        component: () => import("@/components/ConfirmLeave/index.vue"),
        meta: { title: "离开确认" },
      },
    ],
  },

  {
    path: "/forum",
    component: Layout,
    redirect: "/forum-101-1.html",
    name: "Forum",
    // meta: { title: 'Example', icon: 'el-icon-s-help' },
    children: [
      {
        path: "/forum-:id-:current.html",
        name: "ForumShow",
        component: () => import("../views/pages/ForumView.vue"),
        meta: { title: "详情页" },
      },
    ],
  },

  {
    path: "/article",
    component: Layout,
    name: "Article",
    children: [
      {
        path: "/article/create",
        name: "ArticleCreate",
        component: () => import("../views/pages/Article/ArticleCreate.vue"),
      },
      {
        path: "/article/update",
        name: "ArticleUpdate",
        component: () => import("../views/pages/Article/ArticleEdit.vue"),
      },
      {
        path: "/article/:userId/:id.html",
        name: "ArticleView",
        component: () => import("../views/pages/Article/ArticleView.vue"),
      },
    ],
  },
  {
    path: "/thread",
    component: Layout,

    name: "Thread",
    // meta: { title: 'Example', icon: 'el-icon-s-help' },
    children: [
      {
        path: "/thread-:id-:current.html",
        name: "ThreadShow",
        component: () => import("../views/pages/ThreadView"),
        meta: { title: "详情页" },
      },
    ],
  },
  {
    path: "*",
    name: "NotFound",
    component: Layout,
    redirect: "/404",
    children: [
      {
        path: "/404",
        component: () =>
          import(/* webpackChunkName: "not-found" */ "../views/404.vue"),
        meta: { title: "404 - 页面未找到" },
      },
      {
        path: "/403",
        component: () =>
          import(/* webpackChunkName: "not-found" */ "../views/403.vue"),
        meta: { title: "403 - 禁止访问" },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_BASE_URL || "/",
  routes,
});

// 路由守卫：开始导航时显示进度条
router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});

// 路由守卫：导航完成或取消时隐藏进度条
router.afterEach(() => {
  NProgress.done();
});

export default router;
